/**
 * `/coupon/*` routes v2 calls (API_ACCESS.md §3.1), held to the snapshot by `api/routes.test.ts`.
 */
import { gated } from "../../capabilities/access";
import { defineRoutes, route } from "../route";

export const COUPON = defineRoutes("coupon", {
  verify: route<Record<string, unknown>, Record<string, unknown>>(
    "POST",
    "/coupon/verify",
    gated({ modules: ["Sale", "Order", "Support", "Marketing"] }),
    { notes: "a typed code expanded into its discounts; the typed-code source's check (`promotions/partners/port.ts` › `checkCode`)" },
  ),
  redeem: route<Record<string, unknown>, Record<string, unknown>>(
    "POST",
    "/coupon/redeem",
    gated({ modules: ["Sale", "Order", "Support", "Marketing"] }),
    {
      notes:
        "a typed code's OTP, asked of the partner that issued it: needs `couponCode` and `provider` (the partner's `metaId`), reads `customerPhone`, `otp`, `sale`, `requestId`, `extAuthenticated`, `extAuthenticatedBy` and answers the partner's body as it is (coupon_controller.js:70-102; coupon_service.js:901-975). The branch is the token's, not the body's. `sale.channelDefId` is read with no guard, so a call with no `sale` throws",
    },
  ),
  resend: route<Record<string, unknown>, Record<string, unknown>>(
    "POST",
    "/coupon/resend",
    gated({ modules: ["Sale", "Order", "Support", "Marketing"] }),
    {
      notes:
        "a typed code's OTP sent again: `provider` is the provider DOCUMENT (`metaId`, `apiUserName`, `storeCode`), not a `metaId`; needs `sale` too (EasyRewardz alone implements it; any other partner is REST_ERR_INVALID_INPUT); reads `customerPhone`, `couponCode`, `type` (`Coupon` or `Loyalty`) (coupon_controller.js:104-128; api_easyrewardz_service.js:800-880)",
    },
  ),
});
